import { AccessorsMutatorsDecorator } from '../../helpers';
import { TranslatableModel } from './translatable-model';

/**
 * @class ReservationDocument
 */
export class ReservationDocument extends TranslatableModel {

    formatUrl(value = this.url) {

        const split = (value || '').split('/');

        return split[split.length - 1];
    }
}

AccessorsMutatorsDecorator(
    'id',
    'url',
    'name',
    'reservation_id',
    'created_at',
)(ReservationDocument);



// WEBPACK FOOTER //
// ./src/pms-api/models/reservation-document.model.js